export default __webpack_public_path__ + "static/media/trainer-large.2e07ad4e.png";